import RowOne from "./RowOne";
import "./HowWeHelp.css";
import RowTwo from "./RowTwo";
export default function HowWeHelp() {






  return (
    <section
      id="how-we-help"
      className="how-we-help"
    >
      <RowOne />
      <RowTwo />
    </section>
  );
}
